import React from 'react';

const MyComponent = () => {
	return (
		<div>

		</div>
	);
};

export default MyComponent;
